import { render, staticRenderFns } from "./Worship.vue?vue&type=template&id=322bd46c&scoped=true"
import script from "./Worship.vue?vue&type=script&lang=js"
export * from "./Worship.vue?vue&type=script&lang=js"
import style0 from "./Worship.vue?vue&type=style&index=0&id=322bd46c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322bd46c",
  null
  
)

export default component.exports